import React, { useEffect, useRef, useState } from "react";
import { KBD } from "../../utils/Keybindings";
import { listen } from "../../hooks/Listener";
import Label from "../../ui/Label";
import Input from "../../ui/Input";
import Float from "../../ui/Float";
import Space from "../../ui/Space";
import Button from "../../ui/Button";
import { kbdEvent, stringToFile } from "../../utils/Utils";
import { showError } from "../../ui/Message";
import { pubCall } from "../../utils/PubSub";
import Spin from "../../ui/Spin"

export default function ExportCounts(props) {


    const { callback = () => { }, route = "", filters = {} } = props;

    const ref = useRef();
    const [filename, setFilename] = useState("");
    const [loading, setLoading] = useState(false);

    const exportToTextFile = () => {

        if(!filename){
            showError({error : "Must have a filename"})
            return; 
        }

        setLoading(true);
        pubCall("reconciliation.export", {filter : filters?.oh_filter || false}, (_status, _result) => {
            if(_status){
                stringToFile(filename, _result.result);
                callback(false);
            } else {
                showError(_result);
            }
            setLoading(false);
        })
    }

    useEffect(() => {
        if (ref?.current) {
            ref.current.focus();
        }
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.PAGE_DOWN, action: (e) => { exportToTextFile() } }
        ];
        const cleanup = listen(route, actions, (e) => { }, [KBD.ESCAPE, KBD.PAGE_DOWN], [], [KBD.CTRL_C, KBD.CTRL_V]);
        return cleanup;
    }, [filename]);


    return (
        <Spin loading={loading}>
            <div className="shim" /><div className="shim" />
            <Label style={{ "textAlign": "left" }} width={250}>Filename: {filename}</Label>
            <div className="shim" />
            <Input ref={ref} edit onChange={(e) => setFilename(e)} controlled maxLength={40} autoselect width={250} value={filename} />
            <div className="shim" /><div className="shim" />
            <div className="shim" /> <div className="shim" /> <div className="shim" />
            <Float>
                <div></div>
                <Space>
                    <Button kbd={KBD.ESCAPE} onClick={() => kbdEvent(KBD.ESCAPE)} >Cancel</Button>
                    <Button kbd={KBD.PAGE_DOWN} onClick={() => kbdEvent(KBD.PAGE_DOWN)} type="secondary">Export</Button>
                </Space>
            </Float>
        </Spin>
    )
}